<div class="relative flex h-full flex-col overflow-hidden p-1">
  <div class="flex h-5/6 flex-grow">
    <video #video autoplay playsinline webkit-playsinline muted class="h-full w-full object-cover"></video>
    <canvas #canvas class="hidden"></canvas>
  </div>
  <div class="relative flex items-center justify-center gap-16 p-1">
    <div class="flex flex-1 justify-start">
      @if (imageCount > 0) {
        <app-button
          [size]="ButtonSize.LG"
          [style]="ButtonStyle.OUTLINE"
          (click)="goToReview()"
          class="w-full max-w-xs"
          ariaLabel="back to review">
          {{ 'global.back' | translate }}
        </app-button>
      }
    </div>
    <div class="flex-none">
      <app-button
        class="flex rounded-full focus:outline-none"
        icon="camera"
        (click)="capture()"
        [shape]="ButtonShape.ROUNDED"
        [color]="ButtonColor.BLACK"
        [size]="ButtonSize.LG">
      </app-button>
    </div>
    <div class="flex-1"></div>

    <!-- Debug button to toggle logs -->
    <button
      class="absolute bottom-2 right-2 rounded-md bg-gray-800 px-2 py-1 text-xs text-white opacity-70"
      (click)="toggleLogs()">
      {{ showLogs ? 'Hide Logs' : 'Show Logs' }}
    </button>
  </div>

  <!-- Debug logs panel -->
  <div
    *ngIf="showLogs"
    class="absolute bottom-16 left-0 right-0 max-h-60 overflow-y-auto bg-black bg-opacity-80 p-2 text-xs text-white">
    <div class="mb-2 flex justify-between">
      <h4 class="font-bold">Camera Debug Logs</h4>
      <button class="rounded bg-red-600 px-2 text-xs" (click)="clearLogs()">Clear</button>
    </div>
    <div
      *ngFor="let log of uiLogs"
      [ngClass]="{ 'text-red-500': log.isError, 'text-green-400': !log.isError }"
      class="mb-1 border-b border-gray-700 pb-1">
      <span class="text-gray-400">{{ log.timestamp | date: 'HH:mm:ss.SSS' }}:</span> {{ log.message }}
    </div>
    <div *ngIf="uiLogs.length === 0" class="text-gray-400">No logs yet</div>
  </div>
</div>
